/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

//ran this thru claudes code refactoring tool

// redesign this component to look more elegant and polished
// use tailwind css in the className directive 
// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task
// "Colors come from dynamic seller props — use hex + opacity string concatenation (e.g. sellerPrimaryColor1 + '20') for tints, never hardcode colors."

// give me the entire code to copy any insrtuctions to implement

//look at ShopProductGridListView (grid view) and add the same icon hover effects the modal


// here is my current modal component
// include your suggestions
// give me the complete code with instructions


import React, { useState, useEffect, lazy, Suspense } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { FaEye, FaHeart } from "react-icons/fa";
import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
import { MdOutlineRestaurantMenu } from "react-icons/md";
import { IoIosCloseCircle } from "react-icons/io";
import { FaUser } from "react-icons/fa6";

import { add_to_cart, add_to_wishlist } from '../store/reducers/cartReducer';
import { get_event_details } from '../store/reducers/eventDetailsReducer';

import GetSellerConfig from './GetSellerConfig';
import { currencyFormat } from './CurrencyFormat';
import SkeletonWithImage from './SkeletonWithImage';

const Rating = lazy(() => import('./Rating'));

const Divider = ({ sellerPrimaryColor1, sellerColorSuffixMedium, isVisible }) => (
    <div className={`w-full h-px my-2 ${isVisible ? 'block' : 'hidden'}`} 
        style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixMedium }} />
);

/* ─── Icon Button ───────────────────────────────────────────────── */
const IconButton = ({ onClick, hidden, sellerPrimaryColor1, sellerColorSuffixDark, icon, label }) => {
    if (hidden) return null;

    return (
        <button
            type="button"
            onClick={onClick}
            aria-label={label.replace('~', ' ')}
            className="relative w-9 h-9 rounded-full flex items-center justify-center
                    bg-white/95 backdrop-blur-sm border text-sm shadow-md cursor-pointer
                    transition-all duration-200 hover:scale-110 group/icon"
            style={{ 
                color: sellerPrimaryColor1 + sellerColorSuffixDark, 
                borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
            }}>
            <span
                className="flex items-center justify-center
                    transition-transform duration-500
                    group-hover/icon:rotate-[360deg]">
                {icon}
            </span>

            <span
                className="absolute bottom-[110%] left-1/2 -translate-x-1/2
                        text-white text-[11px] font-medium leading-tight text-center
                        px-2 py-1 rounded-md whitespace-nowrap pointer-events-none
                        opacity-0 scale-90 border-2 border-white
                        group-hover/icon:opacity-100 group-hover/icon:scale-100
                        transition-all duration-200 z-10"
                style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                {label.split('~').map((word, i, arr) => (
                    <React.Fragment key={i}>
                        {word}
                        {i < arr.length - 1 && <br />}
                    </React.Fragment>
                ))}
                <span
                    className="absolute -bottom-5 left-1/2 -translate-x-1/2
                        border-[10px] border-transparent border-t-yellow-400" />
            </span>
        </button>
    );
};

/* ─── Detail Pill ───────────────────────────────────────────────── */
const DetailPill = ({ label, value, danger, sellerPrimaryColor1, sellerColorSuffixLight, sellerColorSuffixDark }) => {
    if (!value || value === 'None' || value === 'NoPan') return null;
    return (
        <span
            className="inline-flex items-center gap-1 text-[12px] font-medium px-2 py-0.5 
                rounded-lg mr-1 mb-0.5 border h-5"
            style={{
                backgroundColor: danger ? '#fef2f2' : sellerPrimaryColor1 + sellerColorSuffixLight,
                color: danger ? '#dc2626' : sellerPrimaryColor1 + sellerColorSuffixDark,
                borderColor: danger ? '#fca5a5' : sellerPrimaryColor1 + sellerColorSuffixDark,
            }}>
            {label && <span className="opacity-60 font-normal">{label}:</span>}
            {value}
        </span>
    );
};

/* ─── Modal ─────────────────────────────────────────────────────── */
const Modal2 = ({ isOpen, onClose, product }) => {
    const { userInfo }     = useSelector(state => state.auth);
    const { seller }       = useSelector(state => state.seller);
    const { eventDetails } = useSelector(state => state.eventDetails);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [quantity, setQuantity]       = useState(1);
    const [portionSize, setPortionSize] = useState('');

    const { 
        sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        sellerProductTerm, sellerShoppingTerm, sellerMarketingLine1, sellerBoolShowSiteWishList, sellerBoolShowSiteChat, 
        sellerBoolShowSiteRating, sellerBoolShowCuisineType, sellerBoolShowCookingMethods, sellerBoolShowHoliday, sellerBoolShowKosher
    } = GetSellerConfig();

    const hasActivePackage =
        userInfo && eventDetails?.selectedSellerPackage &&
        eventDetails.selectedSellerPackage !== 'None';

    const showPayments   = !hasActivePackage && seller?.isVisibleSitePayments          === 'Show';
    const showQuantities = !hasActivePackage && seller?.isVisibleSiteProductQuantities === 'Show';

    // ── Lock background scroll while modal is open ──────────────────────────
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        // Cleanup in case the component unmounts while open
        return () => { document.body.style.overflow = ''; };
    }, [isOpen]);

    useEffect(() => {
        if (userInfo?.id) dispatch(get_event_details(userInfo.id));
    }, [dispatch, userInfo?.id]);

    const incrementQty = () => setQuantity(q => q + 1);
    const decrementQty = () => setQuantity(q => Math.max(1, q - 1));

    const handleAddToCart = (id) => {
        if (!userInfo) return navigate('/login');
        dispatch(add_to_cart({ userId: userInfo.id, quantity, productId: id, portionSize }));
        setPortionSize('');
    };

    const handleAddToWishlist = (pro) => {
        if (!userInfo) return navigate('/login');
        dispatch(add_to_wishlist({
            userId: userInfo.id,
            productId: pro._id,
            name: pro.name,
            price: pro.price,
            image: pro.images[0],
            discount: pro.discount,
            rating: pro.rating,
            slug: pro.slug,
            portionSizes: pro.portionSizes,
            description: pro.description,
            byThePan: pro.byThePan,
        }));
    };

    const handleChat = (topic) => {
        if (!userInfo) return navigate('/login');
        navigate(`/customerDashboard/chat/${topic}`);
    };

    // ── Don't render anything into the portal when closed ───────────────────
    if (!isOpen || !product) return null;

    const portionOptions = product.portionSizes
        ? product.portionSizes.split(';').filter(Boolean)
        : [];

    // ── Portal: render directly into document.body ───────────────────────────
    // This escapes any parent stacking context (transform, overflow, z-index)
    // that would otherwise prevent the modal from centering on screen.
    return createPortal(
        /* ── Backdrop ── */
        <div
            onClick={onClose}
            className="fixed inset-0 z-[9999] flex items-center justify-center px-4 bg-black/60">

            {/* ── Card ── */}
            <div className='bg-white rounded-xl p-0'>
                <div
                    className="relative bg-white w-full max-w-lg rounded-xl animate-fade-in-up overflow-hidden"
                    style={{ 
                        border: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`, 
                        borderTop: `5px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`
                    }}  // ← bug fix: was `primaryColor + '55'` inside a template literal, producing a broken string
                    onClick={e => e.stopPropagation()}>
                    {/* ── Top accent strip ── */}
                    <div className="hidden h-1 w-full" style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight }} />
                    <div className="p-3">
                        {/* ── Header ── */}
                        <div className="flex items-start justify-between gap-3 mb-4">
                            <div>
                                <h2 className="text-lg font-semibold leading-snug"
                                    style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                    {product.name}
                                </h2>
                                {showPayments && (
                                    <p className="text-sm font-semibold mt-0.5" 
                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                        {currencyFormat.format(product.price)}
                                    </p>
                                )}
                            </div>
                            <button
                                onClick={onClose}
                                aria-label="Close"
                                className="shrink-0 w-8 h-8 flex items-center justify-center rounded-full 
                                text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-all duration-200">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        {/* ── Image + Description ── */}
                        <div className="grid grid-cols-2 sm:grid-cols-1 gap-2">

                            {/* Image */}
                            <div className="relative group overflow-hidden h-52 border"
                                style={{ borderColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                <SkeletonWithImage
                                    src={product.images[0]}
                                    alt={product.name}
                                    className="w-full h-full object-cover transition-transform duration-700 
                                    ease-in-out group-hover:scale-[1.07]" />

                                <div
                                    className="hidden absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
                                    style={{ background: `linear-gradient(to top, ${sellerPrimaryColor1}${sellerColorSuffixMedium} 0%, transparent 55%)` }}
                                />

                                <div className="absolute bottom-0 left-0 right-0 flex justify-center items-center gap-2 pb-3
                                    translate-y-full group-hover:translate-y-0
                                    transition-transform duration-300 ease-out">
                                    <IconButton
                                        onClick={() => handleAddToCart(product._id)}
                                        sellerPrimaryColor1={sellerPrimaryColor1}
                                        sellerColorSuffixDark={sellerColorSuffixDark}
                                        icon={<MdOutlineRestaurantMenu size={24} />}
                                        label={`Add To~${sellerShoppingTerm}`}
                                    />
                                    <IconButton
                                        onClick={() => handleAddToWishlist(product)}
                                        hidden={!sellerBoolShowSiteWishList}
                                        sellerPrimaryColor1={sellerPrimaryColor1}
                                        sellerColorSuffixDark={sellerColorSuffixDark}
                                        icon={<FaHeart size={16} />}
                                        label="Add To~My Wishlist"
                                    />

                                    <Link
                                        to={`/product/details/${product._id}`}
                                        className="relative w-9 h-9 rounded-full flex items-center justify-center
                                            bg-white/95 backdrop-blur-sm border text-sm shadow-md cursor-pointer
                                            transition-all duration-200 hover:scale-110 group/icon"
                                        style={{ 
                                            color: sellerPrimaryColor1 + sellerColorSuffixDark, 
                                            borderColor: sellerPrimaryColor1 + sellerColorSuffixDark 
                                        }}>
                                        <span
                                            className="flex items-center justify-center
                                                transition-transform duration-500
                                                group-hover/icon:rotate-[360deg]">
                                            <FaEye size={20} />
                                        </span>
                                        <span
                                            className="absolute bottom-[110%] left-1/2 -translate-x-1/2
                                                text-white text-[11px] font-medium leading-tight text-center
                                                px-2 py-1 rounded-md whitespace-nowrap pointer-events-none
                                                opacity-0 scale-90 border-2 border-white
                                                group-hover/icon:opacity-100 group-hover/icon:scale-100
                                                transition-all duration-200 z-10"
                                            style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                            View<br />Details
                                            <span
                                                className="absolute -bottom-5 left-1/2 -translate-x-1/2
                                                    border-[10px] border-transparent border-t-yellow-400" />
                                        </span>
                                    </Link>

                                    <IconButton
                                        onClick={() => handleChat(product.name)}
                                        hidden={!sellerBoolShowSiteChat}
                                        sellerPrimaryColor1={sellerPrimaryColor1}
                                        sellerColorSuffixDark={sellerColorSuffixDark}
                                        icon={<IoChatbubbleEllipsesSharp size={16} />}
                                        label="Chat~With Us"
                                    />
                                </div>
                            </div>

                            {/* Description */}
                            <div
                                className="p-2 text-sm leading-relaxed overflow-y-auto h-52 sm:h-16"
                                style={{
                                    backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                                    border: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                                    color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                }}>
                                {product.description}
                            </div>
                        </div>

                        <Divider sellerPrimaryColor1={sellerPrimaryColor1} sellerColorSuffixMedium={sellerColorSuffixMedium} 
                            isVisible={showQuantities || sellerBoolShowSiteRating || portionOptions.length > 0} />

                        {/* ── Qty + Rating + Portion ── */}
                        <div className="flex flex-wrap items-center gap-3">
                            {showQuantities && (
                                <div
                                    className="flex items-center rounded-lg overflow-hidden"
                                    style={{ border: `1px solid ${sellerPrimaryColor1 + sellerColorSuffixDark}` }}>
                                    <button
                                        onClick={decrementQty}
                                        className="w-8 h-8 flex items-center justify-center text-lg font-light hover:bg-gray-50 transition-colors"
                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                        −
                                    </button>
                                    <span
                                        className="w-8 text-center text-sm font-semibold"
                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                        {quantity}
                                    </span>
                                    <button
                                        onClick={incrementQty}
                                        className="w-8 h-8 flex items-center justify-center text-lg font-light hover:bg-gray-50 transition-colors"
                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                        +
                                    </button>
                                </div>
                            )}

                            {sellerBoolShowSiteRating && (
                                <div className="flex items-center">
                                    <Suspense fallback={null}>
                                        <Rating ratings={product.rating} />
                                    </Suspense>
                                </div>
                            )}

                            {portionOptions.length > 0 && (
                                <select
                                    onChange={e => setPortionSize(e.target.value)}
                                    value={portionSize}
                                    className="flex-1 min-w-[120px] text-sm rounded-lg px-3 py-1.5 font-medium outline-none appearance-none cursor-pointer"
                                    style={{
                                        border: `1px solid ${sellerPrimaryColor1 + sellerColorSuffixDark}`,
                                        backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                                        color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                    }}>
                                    <option value="">Portion size…</option>
                                    {portionOptions.map((p, i) => (
                                        <option key={i} value={p}>{p}</option>
                                    ))}
                                </select>
                            )}
                        </div>

                        <Divider sellerPrimaryColor1={sellerPrimaryColor1} sellerColorSuffixMedium={sellerColorSuffixMedium} isVisible={true} />

                        {/* ── Detail pills ── */}
                        <div className="flex flex-wrap h-6 overflow-y-auto">
                            {sellerBoolShowKosher && product.FMP && (
                                <DetailPill 
                                    value={product.FMP}
                                    sellerPrimaryColor1={sellerPrimaryColor1}
                                    sellerColorSuffixLight={sellerColorSuffixLight}
                                    sellerColorSuffixDark={sellerColorSuffixDark}
                                />
                            )}
                            <DetailPill 
                                label="Category" 
                                value={product.category} 
                                sellerPrimaryColor1={sellerPrimaryColor1}
                                sellerColorSuffixLight={sellerColorSuffixLight}
                                sellerColorSuffixDark={sellerColorSuffixDark} />
                            <DetailPill
                                label="Allergies"
                                value={product.allergies}
                                danger={product.allergies !== 'None'}
                                sellerPrimaryColor1={sellerPrimaryColor1}
                                sellerColorSuffixLight={sellerColorSuffixLight}
                                sellerColorSuffixDark={sellerColorSuffixDark}
                            />
                            {sellerBoolShowCookingMethods && (
                                <DetailPill 
                                    label="Cooking" 
                                    value={product.cookingMethod} 
                                    sellerPrimaryColor1={sellerPrimaryColor1}
                                    sellerColorSuffixLight={sellerColorSuffixLight}
                                    sellerColorSuffixDark={sellerColorSuffixDark} 
                                />
                            )}
                            {product.byThePan !== 'NoPan' && (
                                <DetailPill 
                                    label="By The Pan" 
                                    value={product.byThePan}
                                    sellerPrimaryColor1={sellerPrimaryColor1}
                                    sellerColorSuffixLight={sellerColorSuffixLight}
                                    sellerColorSuffixDark={sellerColorSuffixDark} 
                                />
                            )}
                            {product.dietaryRestrictions !== 'None' && (
                                <DetailPill 
                                    label="Dietary" 
                                    value={product.dietaryRestrictions} 
                                    sellerPrimaryColor1={sellerPrimaryColor1}
                                    sellerColorSuffixLight={sellerColorSuffixLight}
                                    sellerColorSuffixDark={sellerColorSuffixDark} 
                                />
                            )}
                            {sellerBoolShowCuisineType && (
                                <DetailPill 
                                    label="Cuisine" 
                                    value={product.cuisineType} 
                                    sellerPrimaryColor1={sellerPrimaryColor1}
                                    sellerColorSuffixLight={sellerColorSuffixLight}
                                    sellerColorSuffixDark={sellerColorSuffixDark} 
                                />
                            )}
                            {sellerBoolShowHoliday && product.holiday !== 'None' && (
                                <DetailPill 
                                    label="Holiday" 
                                    value={product.holiday} 
                                    sellerPrimaryColor1={sellerPrimaryColor1}
                                    sellerColorSuffixLight={sellerColorSuffixLight}
                                    sellerColorSuffixDark={sellerColorSuffixDark} 
                                />
                            )}
                        </div>

                        {/* ── Marketing line ── */}
                        {sellerMarketingLine1 && (
                            <>
                                <Divider sellerPrimaryColor1={sellerPrimaryColor1} sellerColorSuffixMedium={sellerColorSuffixMedium}
                                    isVisible={true} />
                                <p
                                    className="flex text-[13px] italic text-left px-2 opacity-70 gap-1"
                                    style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                    <div
                                        className='w-9 h-9 rounded-2xl flex items-center justify-center flex-shrink-0'
                                        style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight ?? '#f0f4ff' }}>
                                        <MdOutlineRestaurantMenu className='text-[26px]'  
                                            style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }} />
                                    </div>
                                    {sellerMarketingLine1}
                                </p>
                            </>
                        )}
                        <Divider sellerPrimaryColor1={sellerPrimaryColor1} sellerColorSuffixMedium={sellerColorSuffixMedium} isVisible={true} />

                        {/* ── Action buttons ── */}
                        <div className="grid grid-cols-3 sm:grid-cols-1 items-center gap-2 flex-wrap">
                            <Link
                                to={`/product/details/${product._id}`}
                                className="flex-1 min-w-[150px] flex items-center justify-center gap-1.5 text-sm 
                                    font-medium h-9 rounded-lg transition-all duration-200 hover:brightness-95"
                                style={{
                                    color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                    border: `1px solid ${sellerPrimaryColor1 + sellerColorSuffixDark}`,
                                    backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                                }}>
                                <FaEye size={20} /> {sellerProductTerm} Details
                            </Link>

                            <button
                                onClick={() => handleAddToCart(product._id)}
                                className="flex-1 min-w-[150px] flex items-center justify-center gap-1.5 text-sm font-medium 
                                h-9 rounded-lg text-white transition-all duration-200 hover:brightness-110 active:scale-95"
                                style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                {userInfo
                                    ? <><MdOutlineRestaurantMenu size={18} /> Add to {sellerShoppingTerm}</>
                                    : <><FaUser size={13} /> Please Login</>
                                }
                            </button>

                            <button
                                onClick={onClose}
                                className="h-9 flex min-w-[150px] items-center justify-center gap-1 text-sm font-medium 
                                rounded-lg text-red-500 bg-red-100 transition-all duration-200 border border-red-500">
                                <IoIosCloseCircle size={20} /> Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>,
        document.body   // ← renders outside all parent components into <body>
    );
};

export default Modal2;




//previous vesion - does not work in prodcts component
// import React, { useState, useEffect, lazy } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useNavigate } from 'react-router-dom';

// import { FaEye, FaHeart } from "react-icons/fa";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { IoIosCloseCircle } from "react-icons/io";
// import { FaUser } from "react-icons/fa6";

// import { add_to_cart, add_to_wishlist } from '../store/reducers/cartReducer';
// import { get_event_details } from '../store/reducers/eventDetailsReducer';
// import { currencyFormat } from './CurrencyFormat';
// import SkeletonWithImage from './SkeletonWithImage';

// const Rating = lazy(() => import('./Rating'));

// /* ─── Divider backgroundColor: primaryColor + '22' ───────────────────────────────────────────────────── */
// const Divider = ({ primaryColor, isVisible }) => (
//     <div className={`w-full h-px my-2 ${isVisible ? 'block' : 'hidden'}`} style={{ backgroundColor: primaryColor + '80' }} />
// );

// /* ─── Overlay Icon (matches grid card OverlayIcon) ─────────────── */
// const IconButton = ({ onClick, hidden, primaryColor, icon, label }) => {
//     if (hidden) return null;

//     return (
//         <button
//             type="button"
//             onClick={onClick}
//             aria-label={label.replace('~', ' ')}
//             className="relative w-9 h-9 rounded-full flex items-center justify-center
//                     bg-white/95 backdrop-blur-sm border text-sm shadow-md cursor-pointer
//                     transition-all duration-200 hover:scale-110 group/icon"
//             style={{ color: primaryColor, borderColor: primaryColor + '55' }}
//         >
//             {/* Spinning icon on hover */}
//             <span
//                 className="flex items-center justify-center
//                     transition-transform duration-500
//                     group-hover/icon:rotate-[360deg]"
//             >
//                 {icon}
//             </span>

//             {/* Tooltip */}
//             <span
//                 className="absolute bottom-[110%] left-1/2 -translate-x-1/2
//                         text-white text-[11px] font-medium leading-tight text-center
//                         px-2 py-1 rounded-md whitespace-nowrap pointer-events-none
//                         opacity-0 scale-90 border-2 border-white
//                         group-hover/icon:opacity-100 group-hover/icon:scale-100
//                         transition-all duration-200 z-10"
//                 style={{ backgroundColor: primaryColor }}>
//                 {label.split('~').map((word, i, arr) => (
//                     <React.Fragment key={i}>
//                         {word}
//                         {i < arr.length - 1 && <br />}
//                     </React.Fragment>
//                 ))}
//                 {/* Triangle arrow style={{ borderTopColor: primaryColor }}*/}
//                 <span
//                     className="absolute -bottom-5 left-1/2 -translate-x-1/2
//                         border-[10px] border-transparent border-t-yellow-400" />
//             </span>
//         </button>
//     );
// };

// /* ─── Detail Pill ───────────────────────────────────────────────── */
// const DetailPill = ({ label, value, danger, primaryColor }) => {
//     if (!value || value === 'None' || value === 'NoPan') return null;
//     return (
//         <span
//             className="inline-flex items-center gap-1 text-[12px] font-medium px-2 py-0.5 
//                 rounded-full mr-1 mb-0.5 border h-5"
//             style={{
//                 backgroundColor: danger ? '#fef2f2' : primaryColor + '12',
//                 color: danger ? '#dc2626' : primaryColor,
//                 borderColor: danger ? '#fca5a5' : primaryColor + '55',}}>
//             {label && <span className="opacity-60 font-normal">{label}:</span>}
//             {value}
//         </span>
//     );
// };

// /* ─── Modal ─────────────────────────────────────────────────────── */
// const Modal2 = ({ isOpen, onClose, product }) => {
//     const { userInfo } = useSelector(state => state.auth);
//     const { seller } = useSelector(state => state.seller);
//     const { eventDetails } = useSelector(state => state.eventDetails);

//     const dispatch = useDispatch();
//     const navigate = useNavigate();

//     const [quantity, setQuantity] = useState(1);
//     const [portionSize, setPortionSize] = useState('');

//     const primaryColor = seller.frontEndPrimaryColor1;
//     const secondaryColor = seller.frontEndSecondaryColor1;
//     const productTerm = seller.productTerm;
//     const marketingLine = seller.marketingLine1;
//     const shoppingTerm = seller.shoppingTerm;

//     const showWishlist = seller.isVisibleSiteWishlist === 'Show';
//     const showRating = seller.isVisibleSiteRating === 'Show';
//     const showChat = seller.isVisibleSiteChat === 'Show';
//     const showCuisineType = seller.isVisibleSiteCuisineType === 'Show';
//     const showCookingMethods = seller.isVisibleSiteCookingMethods === 'Show';
//     const showHoliday = seller.isVisibleSiteHoliday === 'Show';

//     const hasActivePackage =
//         userInfo && eventDetails?.selectedSellerPackage &&
//         eventDetails.selectedSellerPackage !== 'None';

//     const showPayments = !hasActivePackage && seller.isVisibleSitePayments === 'Show';
//     const showQuantities = !hasActivePackage && seller.isVisibleSiteProductQuantities === 'Show';

//     useEffect(() => {
//         if (userInfo?.id) dispatch(get_event_details(userInfo.id));
//     }, [dispatch, userInfo?.id]);

//     const handleBackdropClick = (e) => {
//         if (e.target.id === 'modal-backdrop') onClose();
//     };

//     const incrementQty = () => setQuantity(q => q + 1);
//     const decrementQty = () => setQuantity(q => Math.max(1, q - 1));

//     const handleAddToCart = (id) => {
//         if (!userInfo) return navigate('/login');
//         dispatch(add_to_cart({ userId: userInfo.id, quantity, productId: id, portionSize }));
//         setPortionSize('');
//     };

//     const handleAddToWishlist = (pro) => {
//         if (!userInfo) return navigate('/login');
//         dispatch(add_to_wishlist({
//             userId: userInfo.id,
//             productId: pro._id,
//             name: pro.name,
//             price: pro.price,
//             image: pro.images[0],
//             discount: pro.discount,
//             rating: pro.rating,
//             slug: pro.slug,
//             portionSizes: pro.portionSizes,
//             description: pro.description,
//             byThePan: pro.byThePan,
//         }));
//     };

//     const handleChat = (topic) => {
//         if (!userInfo) return navigate('/login');
//         navigate(`/customerDashboard/chat/${topic}`);
//     };

//     if (!isOpen || !product) return null;

//     const portionOptions = product.portionSizes
//         ? product.portionSizes.split(';').filter(Boolean)
//         : [];

//     return (
//         /* ── Backdrop ── */
//         <div
//             id="modal-backdrop"
//             onClick={handleBackdropClick}
//             className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/40">
//             {/* ── Card ── */}
//             <div
//                 className="relative bg-white w-full max-w-lg rounded-xl shadow-2xl animate-fade-in-up overflow-hidden"
//                 style={{ border: `1px solid ${primaryColor} + '55'` }}
//                 onClick={e => e.stopPropagation()}>
//                 {/* ── Top accent strip ── */}
//                 <div className="h-1 w-full" style={{ backgroundColor: primaryColor }} />
                    
//                 <div className="p-3">

//                     {/* ── Header ── */}
//                     <div className="flex items-start justify-between gap-3 mb-4">
//                         <div>
//                             <h2 className="text-lg font-semibold leading-snug"
//                                 style={{ color: primaryColor }}>
//                                 {product.name}
//                             </h2>
//                             {showPayments && (
//                                 <p className="text-sm font-semibold mt-0.5" style={{ color: primaryColor }}>
//                                     {currencyFormat.format(product.price)}
//                                 </p>
//                             )}
//                         </div>
//                         <button
//                             onClick={onClose}
//                             aria-label="Close"
//                             className="shrink-0 w-8 h-8 flex items-center justify-center rounded-full 
//                             text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-all duration-200">
//                             <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M6 18L18 6M6 6l12 12" />
//                             </svg>
//                         </button>
//                     </div>

//                     {/* ── Image + Description ── */}
//                     <div className="grid grid-cols-2 sm:grid-cols-1 gap-2">

//                         {/* Image */}
//                         <div className="relative group overflow-hidden h-52 border"
//                             style={{ borderColor: primaryColor }}>
//                             <SkeletonWithImage
//                                 src={product.images[0]}
//                                 alt={product.name}
//                                 className="w-full h-full object-cover transition-transform duration-700 
//                                 ease-in-out group-hover:scale-[1.07]" />

//                             {/* Gradient overlay ${primaryColor}cc*/}
//                             <div
//                                 className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
//                                 style={{ background: `linear-gradient(to top, ${primaryColor}38 0%, transparent 55%)` }}
//                             />

//                             {/* Icon row — hidden below frame until hover */}
//                             <div className="absolute bottom-0 left-0 right-0 flex justify-center items-center gap-2 pb-3
//                                 translate-y-full group-hover:translate-y-0
//                                 transition-transform duration-300 ease-out">
//                                 <IconButton
//                                     onClick={() => handleAddToCart(product._id)}
//                                     primaryColor={primaryColor}
//                                     icon={<MdOutlineRestaurantMenu size={28} />}
//                                     label={`Add To~${shoppingTerm}`}
//                                 />
//                                 <IconButton
//                                     onClick={() => handleAddToWishlist(product)}
//                                     hidden={!showWishlist}
//                                     primaryColor={primaryColor}
//                                     icon={<FaHeart size={20} />}
//                                     label="Add To~My Wishlist"
//                                 />

//                                 {/* View Details — Link wrapper around OverlayIcon style */}
//                                 <Link
//                                     to={`/product/details/${product._id}`}
//                                     className="relative w-9 h-9 rounded-full flex items-center justify-center
//                                             bg-white/95 backdrop-blur-sm border text-sm shadow-md cursor-pointer
//                                             transition-all duration-200 hover:scale-110 group/icon"
//                                     style={{ color: primaryColor, borderColor: primaryColor + '55' }}>
//                                     <span
//                                         className="flex items-center justify-center
//                                             transition-transform duration-500
//                                             group-hover/icon:rotate-[360deg]">
//                                         <FaEye size={24} />
//                                     </span>
//                                     <span
//                                         className="absolute bottom-[110%] left-1/2 -translate-x-1/2
//                                                 text-white text-[11px] font-medium leading-tight text-center
//                                                 px-2 py-1 rounded-md whitespace-nowrap pointer-events-none
//                                                 opacity-0 scale-90 border-2 border-white
//                                                 group-hover/icon:opacity-100 group-hover/icon:scale-100
//                                                 transition-all duration-200 z-10"
//                                         style={{ backgroundColor: primaryColor }}
//                                     >
//                                         View<br />Details
//                                         <span
//                                             className="absolute -bottom-5 left-1/2 -translate-x-1/2
//                                                 border-[10px] border-transparent border-t-yellow-400" />
//                                     </span>
//                                 </Link>

//                                 <IconButton
//                                     onClick={() => handleChat(product.name)}
//                                     hidden={!showChat}
//                                     primaryColor={primaryColor}
//                                     icon={<IoChatbubbleEllipsesSharp size={20} />}
//                                     label="Chat~With Us"
//                                 />
//                             </div>
//                         </div>

//                         {/* Description */}
//                         <div
//                             className="p-2 text-sm leading-relaxed overflow-y-auto h-52 sm:h-16"
//                             style={{
//                                 backgroundColor: primaryColor + '18',
//                                 border: `1px solid ${primaryColor}`,
//                                 color: primaryColor
//                             }}>
//                             {product.description}
//                         </div>
//                     </div>

//                     <Divider  primaryColor={primaryColor} isVisible={showQuantities || showRating || portionOptions.length > 0} />

//                     {/* ── Qty + Rating + Portion  ── */}
//                     <div className="flex flex-wrap items-center gap-3">
//                         {showQuantities && (
//                             <div
//                                 className="flex items-center rounded-lg overflow-hidden"
//                                 style={{ border: `1px solid ${primaryColor + '30'}` }}
//                             >
//                                 <button
//                                     onClick={decrementQty}
//                                     className="w-8 h-8 flex items-center justify-center text-lg font-light hover:bg-gray-50 transition-colors"
//                                     style={{ color: primaryColor }}
//                                 >
//                                     −
//                                 </button>
//                                 <span
//                                     className="w-8 text-center text-sm font-semibold"
//                                     style={{ color: primaryColor }}
//                                 >
//                                     {quantity}
//                                 </span>
//                                 <button
//                                     onClick={incrementQty}
//                                     className="w-8 h-8 flex items-center justify-center text-lg font-light hover:bg-gray-50 transition-colors"
//                                     style={{ color: primaryColor }}
//                                 >
//                                     +
//                                 </button>
//                             </div>
//                         )}

//                         {showRating && (
//                             <div className="flex items-center">
//                                 <Rating ratings={product.rating} />
//                             </div>
//                         )}

//                         {portionOptions.length > 0 && (
//                             <select
//                                 onChange={e => setPortionSize(e.target.value)}
//                                 value={portionSize}
//                                 className="flex-1 min-w-[120px] text-sm rounded-lg px-3 py-1.5 font-medium outline-none appearance-none cursor-pointer"
//                                 style={{
//                                     border: `1px solid ${primaryColor + '30'}`,
//                                     backgroundColor: primaryColor + '08',
//                                     color: primaryColor,
//                                 }}
//                             >
//                                 <option value="">Portion size…</option>
//                                 {portionOptions.map((p, i) => (
//                                     <option key={i} value={p}>{p}</option>
//                                 ))}
//                             </select>
//                         )}
//                     </div>

//                     <Divider primaryColor={primaryColor} isVisible={true} />

//                     {/* ── Detail pills ── */}
//                     <div className="flex flex-wrap h-6 overflow-y-auto">
//                         {product.FMP && (
//                             <DetailPill value={product.FMP} primaryColor={primaryColor} />
//                         )}
//                         <DetailPill label="Category" value={product.category} primaryColor={primaryColor} />
//                         <DetailPill
//                             label="Allergies"
//                             value={product.allergies}
//                             danger={product.allergies !== 'None'}
//                             primaryColor={primaryColor}
//                         />
//                         {showCookingMethods && (
//                             <DetailPill label="Cooking" value={product.cookingMethod} primaryColor={primaryColor} />
//                         )}
//                         {product.byThePan !== 'NoPan' && (
//                             <DetailPill label="By The Pan" value={product.byThePan} primaryColor={primaryColor} />
//                         )}
//                         {product.dietaryRestrictions !== 'None' && (
//                             <DetailPill label="Dietary" value={product.dietaryRestrictions} primaryColor={primaryColor} />
//                         )}
//                         {showCuisineType && (
//                             <DetailPill label="Cuisine" value={product.cuisineType} primaryColor={primaryColor} />
//                         )}
//                         {showHoliday && product.holiday !== 'None' && (
//                             <DetailPill label="Holiday" value={product.holiday} primaryColor={primaryColor} />
//                         )}
//                     </div>

//                     {/* ── Marketing line ── */}
//                     {marketingLine && (
//                         <>
//                             <Divider primaryColor={primaryColor}  isVisible={true} />
//                             <p
//                                 className="flex text-[13px] italic text-left px-2 opacity-70 gap-1"
//                                 style={{ color: primaryColor }}>

//                                 <div
//                                     className='w-9 h-9 rounded-2xl flex items-center justify-center flex-shrink-0'
//                                     style={{ backgroundColor: secondaryColor ?? '#f0f4ff' }}>
//                                     <MdOutlineRestaurantMenu className='text-[26px]' style={{ color: primaryColor }} />
//                                 </div> 
//                                 {marketingLine}
//                             </p>
//                         </>
//                     )}
//                     <Divider primaryColor={primaryColor} isVisible={true} />

//                     {/* ── Action buttons ── */}
//                     <div className="grid grid-cols-3 sm:grid-cols-1 items-center gap-2 flex-wrap">
//                         <Link
//                             to={`/product/details/${product._id}`}
//                             className="flex-1 min-w-[150px] flex items-center justify-center gap-1.5 text-sm 
//                                 font-medium h-9 rounded-lg transition-all duration-200 hover:brightness-95"
//                             style={{
//                                 color: primaryColor,
//                                 border: `1px solid ${primaryColor + '55'}`,
//                                 backgroundColor: primaryColor + '18',}}>
//                             <FaEye size={18} /> Details
//                         </Link>

//                         <button
//                             onClick={() => handleAddToCart(product._id)}
//                             className="flex-1 min-w-[150px] flex items-center justify-center gap-1.5 text-sm font-medium 
//                             h-9 rounded-lg text-white transition-all duration-200 hover:brightness-110 active:scale-95"
//                             style={{ backgroundColor: primaryColor }}>
//                             {userInfo
//                                 ? <><MdOutlineRestaurantMenu size={18} /> Add to {shoppingTerm}</>
//                                 : <><FaUser size={13} /> Please Login</>
//                             }
//                         </button>

//                         <button
//                             onClick={onClose}
//                             className="h-9 flex min-w-[150px] items-center justify-center gap-1 text-sm font-medium 
//                             rounded-lg text-red-500 bg-red-100 transition-all duration-200 border border-red-500">
//                             <IoIosCloseCircle size={20} /> Close
//                         </button>
//                     </div>

//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Modal2;




// import React, { useState, useEffect, lazy } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useNavigate } from 'react-router-dom';

// import { FaEye, FaHeart } from "react-icons/fa";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { IoIosCloseCircle } from "react-icons/io";
// import { FaUser } from "react-icons/fa6";

// import { add_to_cart, add_to_wishlist } from '../store/reducers/cartReducer';
// import { get_event_details } from '../store/reducers/eventDetailsReducer';
// import { currencyFormat } from './CurrencyFormat';
// import SkeletonWithImage from './SkeletonWithImage';
// import ShopProductGridListView from './products/ShopProductGridListView';

// const Rating = lazy(() => import('./Rating'));

// /* ─── Divider ───────────────────────────────────────────────────── */
// const Divider = ({ primaryColor }) => (
//     <div className="w-full h-px my-3" style={{ backgroundColor: primaryColor + '22' }} />
// );

// /* ─── Icon Action Button ────────────────────────────────────────── */
// const IconButton = ({ onClick, hidden, primaryColor, icon, label }) => {
//     if (hidden) return null;
//     return (
//         <li
//             onClick={onClick}
//             className="w-9 h-9 cursor-pointer flex justify-center items-center rounded-full bg-white 
//             transition-all duration-200 hover:scale-110"
//             style={{ color: primaryColor, border: `1.5px solid ${primaryColor + '60'}` }}
//         >
//             <span className="flex items-center text-base">{icon}</span>
//         </li>
//     );
// };

// /* ─── Detail Pill ───────────────────────────────────────────────── */
// const DetailPill = ({ label, value, danger, primaryColor }) => {
//     if (!value || value === 'None' || value === 'NoPan') return null;
//     return (
//         <span
//             className="inline-flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full mr-1 mb-1"
//             style={{
//                 backgroundColor: danger ? '#fef2f2' : primaryColor + '12',
//                 color: danger ? '#dc2626' : primaryColor,
//             }}
//         >
//             {label && <span className="opacity-60 font-normal">{label}:</span>}
//             {value}
//         </span>
//     );
// };

// /* ─── Modal ─────────────────────────────────────────────────────── */
// const Modal2 = ({ isOpen, onClose, product }) => {
//     const { userInfo } = useSelector(state => state.auth);
//     const { seller } = useSelector(state => state.seller);
//     const { eventDetails } = useSelector(state => state.eventDetails);

//     const dispatch = useDispatch();
//     const navigate = useNavigate();

//     const [quantity, setQuantity] = useState(1);
//     const [portionSize, setPortionSize] = useState('');

//     const primaryColor = seller.frontEndPrimaryColor1;
//     const secondaryColor = seller.frontEndSecondaryColor1;
//     const productTerm = seller.productTerm;
//     const marketingLine = seller.marketingLine1;
//     const shoppingTerm = seller.shoppingTerm;

//     const showWishlist = seller.isVisibleSiteWishlist === 'Show';
//     const showRating = seller.isVisibleSiteRating === 'Show';
//     const showChat = seller.isVisibleSiteChat === 'Show';
//     const showCuisineType = seller.isVisibleSiteCuisineType === 'Show';
//     const showCookingMethods = seller.isVisibleSiteCookingMethods === 'Show';
//     const showHoliday = seller.isVisibleSiteHoliday === 'Show';

//     const hasActivePackage =
//         userInfo && eventDetails?.selectedSellerPackage &&
//         eventDetails.selectedSellerPackage !== 'None';

//     const showPayments = !hasActivePackage && seller.isVisibleSitePayments === 'Show';
//     const showQuantities = !hasActivePackage && seller.isVisibleSiteProductQuantities === 'Show';

//     useEffect(() => {
//         if (userInfo?.id) dispatch(get_event_details(userInfo.id));
//     }, [dispatch, userInfo?.id]);

//     const handleBackdropClick = (e) => {
//         if (e.target.id === 'modal-backdrop') onClose();
//     };

//     const incrementQty = () => setQuantity(q => q + 1);
//     const decrementQty = () => setQuantity(q => Math.max(1, q - 1));

//     const handleAddToCart = (id) => {
//         if (!userInfo) return navigate('/login');
//         dispatch(add_to_cart({ userId: userInfo.id, quantity, productId: id, portionSize }));
//         setPortionSize('');
//     };

//     const handleAddToWishlist = (pro) => {
//         if (!userInfo) return navigate('/login');
//         dispatch(add_to_wishlist({
//             userId: userInfo.id,
//             productId: pro._id,
//             name: pro.name,
//             price: pro.price,
//             image: pro.images[0],
//             discount: pro.discount,
//             rating: pro.rating,
//             slug: pro.slug,
//             portionSizes: pro.portionSizes,
//             description: pro.description,
//             byThePan: pro.byThePan,
//         }));
//     };

//     const handleChat = (topic) => {
//         if (!userInfo) return navigate('/login');
//         navigate(`/customerDashboard/chat/${topic}`);
//     };

//     if (!isOpen || !product) return null;

//     const portionOptions = product.portionSizes
//         ? product.portionSizes.split(';').filter(Boolean)
//         : [];

//     return (
//         /* ── Backdrop ── */
//         <div
//             id="modal-backdrop"
//             onClick={handleBackdropClick}
//             className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/40"
//         >
//             {/* ── Card ── */}
//             <div
//                 className="relative bg-white w-full max-w-lg rounded-xl shadow-2xl animate-fade-in-up overflow-hidden"
//                 style={{ border: `1px solid ${primaryColor + '22'}` }}
//                 onClick={e => e.stopPropagation()}
//             >
//                 {/* ── Top accent strip ── */}
//                 <div className="h-1 w-full" style={{ backgroundColor: primaryColor }} />

//                 <div className="p-5">

//                     {/* ── Header ── */}
//                     <div className="flex items-start justify-between gap-3 mb-4">
//                         <div>
//                             <h2 className="text-lg font-semibold leading-snug"
//                                 style={{ color: primaryColor }}>
//                                 {product.name}
//                             </h2>
//                             {showPayments && (
//                                 <p className="text-sm font-semibold mt-0.5" style={{ color: primaryColor }}>
//                                     {currencyFormat.format(product.price)}
//                                 </p>
//                             )}
//                         </div>
//                         <button
//                             onClick={onClose}
//                             aria-label="Close"
//                             className="shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-all duration-200"
//                         >
//                             <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M6 18L18 6M6 6l12 12" />
//                             </svg>
//                         </button>
//                     </div>

//                     {/* ── Image + Description ── */}
//                     <div className="grid grid-cols-2 gap-3">

//                         {/* Image */}
//                         <div className="relative group overflow-hidden h-52 border"
//                             style={{ borderColor: primaryColor }}>
//                             <SkeletonWithImage
//                                 src={product.images[0]}
//                                 alt={product.name}
//                                 className="w-full h-full object-cover"
//                             />

//                             {/* Gradient overlay */}
//                             <div
//                                 className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none rounded-lg"
//                                 style={{ background: `linear-gradient(to top, ${primaryColor}cc 0%, transparent 55%)` }}
//                             />

//                             {/* Icon row — hidden below frame until hover */}
//                             <ul className="absolute bottom-0 left-0 right-0 flex justify-center items-center gap-2 pb-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out">
//                                 <IconButton
//                                     onClick={() => handleAddToCart(product._id)}
//                                     primaryColor={primaryColor}
//                                     icon={<MdOutlineRestaurantMenu />}
//                                     label={`Add to ${shoppingTerm}`}
//                                 />
//                                 <IconButton
//                                     onClick={() => handleAddToWishlist(product)}
//                                     hidden={!showWishlist}
//                                     primaryColor={primaryColor}
//                                     icon={<FaHeart />}
//                                     label="Wishlist"
//                                 />
//                                 <li
//                                     className="w-9 h-9 flex items-center justify-center rounded-full bg-white transition-all duration-200 hover:scale-110"
//                                     style={{ color: primaryColor, border: `1.5px solid ${primaryColor + '60'}` }}
//                                 >
//                                     <Link to={`/product/details/${product._id}`}>
//                                         <FaEye />
//                                     </Link>
//                                 </li>
//                                 <IconButton
//                                     onClick={() => handleChat(product.name)}
//                                     hidden={!showChat}
//                                     primaryColor={primaryColor}
//                                     icon={<IoChatbubbleEllipsesSharp />}
//                                     label="Chat"
//                                 />
//                             </ul>
//                         </div>
//                         {/* Description */}
//                         <div
//                             className="p-2 text-sm leading-relaxed overflow-y-auto h-52"
//                             style={{
//                                 backgroundColor: primaryColor + '18',
//                                 border: `1px solid ${primaryColor}`,
//                                 color: primaryColor
//                             }}>
//                             {product.description}
//                         </div>
//                     </div>

//                     <Divider primaryColor={primaryColor} />

//                     {/* ── Qty + Rating + Portion ── */}
//                     <div className="flex flex-wrap items-center gap-3">
//                         {showQuantities && (
//                             <div
//                                 className="flex items-center rounded-lg overflow-hidden"
//                                 style={{ border: `1px solid ${primaryColor + '30'}` }}
//                             >
//                                 <button
//                                     onClick={decrementQty}
//                                     className="w-8 h-8 flex items-center justify-center text-lg font-light hover:bg-gray-50 transition-colors"
//                                     style={{ color: primaryColor }}
//                                 >
//                                     −
//                                 </button>
//                                 <span
//                                     className="w-8 text-center text-sm font-semibold"
//                                     style={{ color: primaryColor }}
//                                 >
//                                     {quantity}
//                                 </span>
//                                 <button
//                                     onClick={incrementQty}
//                                     className="w-8 h-8 flex items-center justify-center text-lg font-light hover:bg-gray-50 transition-colors"
//                                     style={{ color: primaryColor }}
//                                 >
//                                     +
//                                 </button>
//                             </div>
//                         )}

//                         {showRating && (
//                             <div className="flex items-center">
//                                 <Rating ratings={product.rating} />
//                             </div>
//                         )}

//                         {portionOptions.length > 0 && (
//                             <select
//                                 onChange={e => setPortionSize(e.target.value)}
//                                 value={portionSize}
//                                 className="flex-1 min-w-[120px] text-sm rounded-lg px-3 py-1.5 font-medium outline-none appearance-none cursor-pointer"
//                                 style={{
//                                     border: `1px solid ${primaryColor + '30'}`,
//                                     backgroundColor: primaryColor + '08',
//                                     color: primaryColor,
//                                 }}
//                             >
//                                 <option value="">Portion size…</option>
//                                 {portionOptions.map((p, i) => (
//                                     <option key={i} value={p}>{p}</option>
//                                 ))}
//                             </select>
//                         )}
//                     </div>

//                     <Divider primaryColor={primaryColor} />

//                     {/* ── Detail pills ── */}
//                     <div className="flex flex-wrap">
//                         {product.FMP && (
//                             <DetailPill value={product.FMP} primaryColor={primaryColor} />
//                         )}
//                         <DetailPill label="Category" value={product.category} primaryColor={primaryColor} />
//                         <DetailPill
//                             label="Allergies"
//                             value={product.allergies}
//                             danger={product.allergies !== 'None'}
//                             primaryColor={primaryColor}
//                         />
//                         {showCookingMethods && (
//                             <DetailPill label="Cooking" value={product.cookingMethod} primaryColor={primaryColor} />
//                         )}
//                         {product.byThePan !== 'NoPan' && (
//                             <DetailPill label="By The Pan" value={product.byThePan} primaryColor={primaryColor} />
//                         )}
//                         {product.dietaryRestrictions !== 'None' && (
//                             <DetailPill label="Dietary" value={product.dietaryRestrictions} primaryColor={primaryColor} />
//                         )}
//                         {showCuisineType && (
//                             <DetailPill label="Cuisine" value={product.cuisineType} primaryColor={primaryColor} />
//                         )}
//                         {showHoliday && product.holiday !== 'None' && (
//                             <DetailPill label="Holiday" value={product.holiday} primaryColor={primaryColor} />
//                         )}
//                     </div>

//                     {/* ── Marketing line ── */}
//                     {marketingLine && (
//                         <>
//                             <Divider primaryColor={primaryColor} />
//                             <p
//                                 className="text-xs italic text-center px-2 opacity-70"
//                                 style={{ color: primaryColor }}
//                             >
//                                 {marketingLine}
//                             </p>
//                         </>
//                     )}

//                     <Divider primaryColor={primaryColor} />

//                     {/* ── Action buttons ── */}
//                     <div className="flex items-center gap-2 flex-wrap">
//                         <Link
//                             to={`/product/details/${product._id}`}
//                             className="flex-1 min-w-[90px] flex items-center justify-center gap-1.5 text-sm font-medium h-9 rounded-lg transition-all duration-200 hover:brightness-95"
//                             style={{
//                                 color: primaryColor,
//                                 border: `1px solid ${primaryColor + '40'}`,
//                                 backgroundColor: primaryColor + '08',
//                             }}
//                         >
//                             <FaEye size={13} /> Details
//                         </Link>

//                         <button
//                             onClick={() => handleAddToCart(product._id)}
//                             className="flex-1 min-w-[120px] flex items-center justify-center gap-1.5 text-sm font-medium h-9 rounded-lg text-white transition-all duration-200 hover:brightness-110 active:scale-95"
//                             style={{ backgroundColor: primaryColor }}
//                         >
//                             {userInfo
//                                 ? <><MdOutlineRestaurantMenu size={15} /> Add to {shoppingTerm}</>
//                                 : <><FaUser size={13} /> Login to Order</>
//                             }
//                         </button>

//                         <button
//                             onClick={onClose}
//                             className="h-9 px-4 flex items-center justify-center gap-1 text-sm font-medium rounded-lg text-gray-500 hover:bg-gray-100 transition-all duration-200"
//                         >
//                             <IoIosCloseCircle size={15} /> Close
//                         </button>
//                     </div>

//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Modal2;




//below is the original code bfero redesign
// import React, { useState, useEffect, lazy } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useNavigate } from 'react-router-dom';

// import { FaEye, FaHeart } from "react-icons/fa";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { IoIosCloseCircle } from "react-icons/io";
// import { FaUser } from "react-icons/fa6";

// import { add_to_cart, add_to_wishlist } from '../store/reducers/cartReducer';
// import { get_event_details } from '../store/reducers/eventDetailsReducer';
// import { currencyFormat } from './CurrencyFormat';
// import SkeletonWithImage from './SkeletonWithImage';

// const Rating = lazy(() => import('./Rating'));

// const IconButton = ({ onClick, hidden, primaryColor, tooltipStyle, icon, label }) => {
//     if (hidden) return null;
//     return (
//         <li
//             onClick={onClick}
//             className="w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all"
//             style={{ color: primaryColor, borderColor: primaryColor }}
//         >
//             <div className="icon-container">
//                 <span className="icon flex justify-center items-center">&nbsp;{icon}&nbsp;</span>
//                 <div className="tooltipSmall" style={tooltipStyle}>{label}</div>
//             </div>
//         </li>
//     );
// };

// const Modal2 = ({ isOpen, onClose, product, productId }) => {
//     const { userInfo } = useSelector(state => state.auth);
//     const { seller } = useSelector(state => state.seller);
//     const { eventDetails } = useSelector(state => state.eventDetails);

//     const dispatch = useDispatch();
//     const navigate = useNavigate();

//     const [quantity, setQuantity] = useState(1);
//     const [portionSize, setPortionSize] = useState('');

//     // Seller config
//     const sellerId = seller._id;
//     const primaryColor = seller.frontEndPrimaryColor1;
//     const secondaryColor = seller.frontEndSecondaryColor1;
//     const productTerm = seller.productTerm;
//     const marketingLine = seller.marketingLine1;
//     const shoppingTerm = seller.shoppingTerm;

//     const showWishlist = seller.isVisibleSiteWishlist === 'Show';
//     const showRating = seller.isVisibleSiteRating === 'Show';
//     const showChat = seller.isVisibleSiteChat === 'Show';
//     const showCuisineType = seller.isVisibleSiteCuisineType === 'Show';
//     const showCookingMethods = seller.isVisibleSiteCookingMethods === 'Show';
//     const showHoliday = seller.isVisibleSiteHoliday === 'Show';

//     // Derive payment/quantity visibility (with event package override)
//     const hasActivePackage =
//         userInfo && eventDetails?.selectedSellerPackage &&
//         eventDetails.selectedSellerPackage !== 'None';

//     const showPayments = !hasActivePackage && seller.isVisibleSitePayments === 'Show';
//     const showQuantities = !hasActivePackage && seller.isVisibleSiteProductQuantities === 'Show';

//     const tooltipStyle = { color: 'white', backgroundColor: primaryColor };
//     const brandStyle = { color: primaryColor };
//     const brandBorderStyle = { color: primaryColor, borderColor: primaryColor };
//     const brandFullStyle = { color: primaryColor, borderColor: primaryColor, backgroundColor: secondaryColor };
//     const btnStyle = { backgroundColor: primaryColor };

//     useEffect(() => {
//         if (userInfo?.id) {
//             dispatch(get_event_details(userInfo.id));
//         }
//     }, [dispatch, userInfo?.id]);

//     const handleBackdropClick = (e) => {
//         if (e.target.id === 'wrapper') onClose();
//     };

//     const incrementQty = () => setQuantity(q => q + 1);
//     const decrementQty = () => setQuantity(q => Math.max(1, q - 1));

//     const handleAddToCart = (id) => {
//         if (!userInfo) return navigate('/login');
//         dispatch(add_to_cart({
//             userId: userInfo.id,
//             quantity,
//             productId: id,
//             portionSize,
//         }));
//         setPortionSize('');
//     };

//     const handleAddToWishlist = (pro) => {
//         if (!userInfo) return navigate('/login');
//         dispatch(add_to_wishlist({
//             userId: userInfo.id,
//             productId: pro._id,
//             name: pro.name,
//             price: pro.price,
//             image: pro.images[0],
//             discount: pro.discount,
//             rating: pro.rating,
//             slug: pro.slug,
//             portionSizes: pro.portionSizes,
//             description: pro.description,
//             byThePan: pro.byThePan,
//         }));
//     };

//     const handleChat = (topic) => {
//         if (!userInfo) return navigate('/login');
//         navigate(`/customerDashboard/chat/${topic}`);
//     };

//     if (!isOpen || !product) return null;

//     const portionOptions = product.portionSizes
//         ? product.portionSizes.split(';').filter(Boolean)
//         : [];

//     return (
//         <div
//             id="wrapper"
//             onClick={handleBackdropClick}
//             className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
//         >
//             <div
//                 id="modal"
//                 className="bg-white z-[1000] border-2 p-3 shadow-xl w-full max-w-md"
//                 style={{ color: primaryColor, borderColor: primaryColor }}
//             >
//                 {/* Header */}
//                 <div className="flex justify-between items-center mb-4">
//                     <div className="text-xl font-semibold">{product.name}</div>
//                     <button
//                         onClick={onClose}
//                         className="w-[34px] h-[34px] border-none text-gray-700 hover:bg-gray-700 cursor-pointer
//                             flex justify-center items-center rounded-full hover:rotate-[720deg] transition-all bg-white hover:text-white"
//                         aria-label="Close modal"
//                     >
//                         <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                         </svg>
//                     </button>
//                 </div>

//                 {/* Image + Description */}
//                 <div className="grid grid-cols-2 gap-2 justify-between items-center">
//                     <div className="relative group h-[210px] md:h-[270px] xs:h-[170px] overflow-hidden">
//                         <SkeletonWithImage
//                             className="sm:w-full object-cover border"
//                             style={{ height: '100%', width: '100%', borderColor: primaryColor }}
//                             src={product.images[0]}
//                             alt={product.name}
//                         />
//                         <ul className="group-hover:bottom-6 flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full">
//                             <IconButton
//                                 onClick={() => handleAddToCart(product._id)}
//                                 primaryColor={primaryColor}
//                                 tooltipStyle={tooltipStyle}
//                                 icon={<><span>+</span><MdOutlineRestaurantMenu /></>}
//                                 label={<>Add To<br />{shoppingTerm}</>}
//                             />
//                             <IconButton
//                                 onClick={() => handleAddToWishlist(product)}
//                                 hidden={!showWishlist}
//                                 primaryColor={primaryColor}
//                                 tooltipStyle={tooltipStyle}
//                                 icon={<FaHeart />}
//                                 label={<>Add To<br />Wishlist</>}
//                             />
//                             <li>
//                                 <Link
//                                     to={`/product/details/${product._id}`}
//                                     className="w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all"
//                                     style={{ backgroundColor: 'white', color: primaryColor, borderColor: primaryColor }}
//                                 >
//                                     <div className="icon-container">
//                                         <span className="icon flex justify-center items-center">&nbsp;<FaEye />&nbsp;</span>
//                                         <div className="tooltipSmall" style={tooltipStyle}>More<br />Details</div>
//                                     </div>
//                                 </Link>
//                             </li>
//                             <IconButton
//                                 onClick={() => handleChat(product.name)}
//                                 hidden={!showChat}
//                                 primaryColor={primaryColor}
//                                 tooltipStyle={tooltipStyle}
//                                 icon={<IoChatbubbleEllipsesSharp />}
//                                 label={<>Chat<br />With Us</>}
//                             />
//                         </ul>
//                     </div>

//                     {/* Description */}
//                     <div
//                         className="h-[210px] md:h-[270px] xs:h-[170px] border overflow-y-auto p-1 text-sm"
//                         style={brandFullStyle}
//                     >
//                         {product.description}
//                     </div>
//                 </div>

//                 {/* Price / Qty / Rating / Portion */}
//                 <div className="grid grid-cols-2 gap-2 p-1">
//                     <div className="grid grid-cols-2 gap-2 p-1">
//                         {showPayments && (
//                             <span className="text-md font-semibold">
//                                 {currencyFormat.format(product.price)}
//                             </span>
//                         )}
//                         {showQuantities && (
//                             <span
//                                 className="flex border rounded-lg w-[60px] h-[24px] mb-1 justify-center items-center"
//                                 style={{ borderColor: primaryColor, backgroundColor: secondaryColor }}
//                             >
//                                 <button onClick={decrementQty} className="px-1 text-[15px] font-semibold cursor-pointer" style={brandStyle}>-</button>
//                                 <span className="px-1 text-[15px] font-semibold" style={brandStyle}>{quantity}</span>
//                                 <button onClick={incrementQty} className="px-1 text-[15px] font-semibold cursor-pointer" style={brandStyle}>+</button>
//                             </span>
//                         )}
//                         {showRating && (
//                             <div className="flex">
//                                 <Rating ratings={product.rating} />
//                             </div>
//                         )}
//                     </div>

//                     {portionOptions.length > 0 && (
//                         <select
//                             onChange={(e) => setPortionSize(e.target.value)}
//                             value={portionSize}
//                             className="border rounded-md px-1 py-1 mb-1 w-full text-[14px] font-semibold"
//                             style={brandFullStyle}
//                         >
//                             <option value="">Choose Portion Size</option>
//                             {portionOptions.map((p, i) => (
//                                 <option key={i} value={p}>{p}</option>
//                             ))}
//                         </select>
//                     )}
//                 </div>

//                 {/* Product details */}
//                 <div className="gap-2 p-1 border mt-1 text-sm" style={brandFullStyle}>
//                     <span className="font-semibold">{productTerm} Details: </span>
//                     {product.FMP && <span className="mr-1">{product.FMP};</span>}
//                     <span className="mr-1">Category: <b>{product.category}</b>;</span>
//                     <span className={`mr-1 ${product.allergies !== 'None' ? 'font-semibold text-red-500' : ''}`}>
//                         Allergies: <b>{product.allergies}</b>;
//                     </span>
//                     {showCookingMethods && (
//                         <span className="mr-1">Cooking Method: <b>{product.cookingMethod}</b>;</span>
//                     )}
//                     {product.byThePan !== 'NoPan' && (
//                         <span className="mr-1">By The Pan: <b>{product.byThePan}</b>;</span>
//                     )}
//                     {product.dietaryRestrictions !== 'None' && (
//                         <span className="mr-1">Dietary Restrictions: <b>{product.dietaryRestrictions}</b>;</span>
//                     )}
//                     {showCuisineType && (
//                         <span className="mr-1">Cuisine Type: <b>{product.cuisineType}</b></span>
//                     )}
//                     {showHoliday && product.holiday !== 'None' && (
//                         <span className="mr-1">Holiday: <b>{product.holiday}</b></span>
//                     )}
//                 </div>

//                 {/* Marketing line */}
//                 <div className="gap-2 p-1 border text-sm italic mt-2" style={brandFullStyle}>
//                     {marketingLine}
//                 </div>

//                 {/* Action buttons */}
//                 <div className="flex justify-center gap-1 mt-1 xs:grid xs:grid-cols-2">
//                     <Link
//                         to={`/product/details/${product._id}`}
//                         style={btnStyle}
//                         className="p-3 mt-1 h-[34px] w-[130px] xs:w-[152px] xs:mr-2 text-sm font-semibold text-white flex justify-center items-center rounded-lg"
//                     >
//                         <FaEye className="mr-1" /> More Details
//                     </Link>
//                     <button
//                         onClick={() => handleAddToCart(product._id)}
//                         style={btnStyle}
//                         className="p-3 mt-1 h-[34px] w-[154px] text-sm font-semibold flex rounded-lg cursor-pointer justify-center items-center text-white"
//                     >
//                         {userInfo
//                             ? <><MdOutlineRestaurantMenu className="mr-1" /> Add To {shoppingTerm}</>
//                             : <><FaUser className="mr-1" /> Please Login</>
//                         }
//                     </button>
//                     <button
//                         onClick={onClose}
//                         style={btnStyle}
//                         className="p-3 mt-1 h-[34px] w-[80px] xs:w-[152px] text-sm font-semibold text-white flex justify-center items-center rounded-lg"
//                     >
//                         <IoIosCloseCircle className="mr-1" /> Close
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Modal2;



//my original code
// import React, {useState, useEffect, lazy} from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useNavigate } from 'react-router-dom';

// import { FaEye, FaRegHeart, FaHeart } from "react-icons/fa";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { RiShoppingCartLine } from "react-icons/ri";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { IoIosCloseCircle } from "react-icons/io";
// import { FaUser } from "react-icons/fa6";

// import { add_to_cart, add_to_wishlist, messageClear } from '../store/reducers/cartReducer';
// import { get_event_details } from '../store/reducers/eventDetailsReducer';

// import { currencyFormat } from './CurrencyFormat';
// import SkeletonWithImage from './SkeletonWithImage';

// const Rating  = lazy(()=> import('./Rating')) 

// // gemini qurey create react code to for variable number of multiple modal popups for products on 1 page
// // create react code to for variable multiple modal popups on 1 page with children with tailwind css

// const Modal2 = ({ isOpen, onClose, product, productId }) => {
//     const { userInfo } = useSelector(state => state.auth)
//     const { seller } = useSelector(state => state.seller)
//     const { eventDetails } = useSelector(state => state.eventDetails);
//     //console.log('seller in Modal2 ', seller)

//     const sellerId = seller._id 
//     const sellerPrimaryColor1 = seller.frontEndPrimaryColor1 // + ' !important'
//     //const sellerPrimaryColor11 = '!important' + seller.frontEndPrimaryColor1
//     const sellerSecondaryColor1 = seller.frontEndSecondaryColor1
//     const sellerProductTerm = seller.productTerm
//     const sellerCompanyMarketingLine1 = seller.marketingLine1
//     const sellerShoppingTerm = seller.shoppingTerm

//     const sellerBoolShowSiteWishList = seller.isVisibleSiteWishlist === 'Show' ? true : false
//     const sellerBoolShowSiteRating = seller.isVisibleSiteRating === 'Show' ? true : false
//     const sellerBoolShowSiteChat = seller.isVisibleSiteChat === 'Show' ? true : false
//     const sellerBoolShowCuisineType = seller.isVisibleSiteCuisineType === 'Show' ? true : false
//     const sellerBoolShowSiteCookingMethods = seller.isVisibleSiteCookingMethods === 'Show' ? true : false
//     const sellerBoolShowSiteHoliday = seller.isVisibleSiteHoliday === 'Show' ? true : false

//     let sellerBoolShowSitePayments = seller.isVisibleSitePayments === 'Show' ? true : false
//     let sellerBoolShowSiteProductQuantities = seller.isVisibleSiteProductQuantities === 'Show' ? true : false

//     const tooltipHoverStyle = {
//         color: 'white',
//         backgroundColor: sellerPrimaryColor1
//     };

//     const [portionSize, setPortionSize] = useState('')
//     const handleClose = (e) => {
//         if(e.target.id === 'wrapper') {
//             onClose();    
//         }
//     }
    
//     const navigate = useNavigate()
//     const dispatch = useDispatch()

//     const [quantity, setQuantity] = useState(1)
//     const cartProductQuantityIncrementLocal = () => {
//         setQuantity(quantity + 1)
//     }
//     const cartProductQuantityDecrementLocal = () => {
//         if (quantity > 1) {
//             setQuantity(quantity - 1)
//         }
//     }

//     useEffect(() => {
//         if (userInfo) {
//             dispatch(get_event_details(userInfo.id))
//         }
//     },[userInfo.id])

//     const setPaymentsAndQuantitiesLocal = () => {
//         if (userInfo) {
//             if (eventDetails?.selectedSellerPackage !== undefined) {
//                 //console.log(eventDetails?.selectedSellerPackage) 
//                 if (eventDetails) {
//                     if (eventDetails?.selectedSellerPackage !== 'None') {
//                         sellerBoolShowSitePayments = false
//                         sellerBoolShowSiteProductQuantities = false
//                     } else {
//                         //sellerBoolShowSitePayments = true
//                         //sellerBoolShowSiteProductQuantities = true
//                     }
//                 }
//             }
//         }
//     }
//     const add_to_cart_local = (id) => {
//         if (userInfo) {
//             //console.log('productId ', id)
//             //console.log('userId ', userInfo.id)
//             dispatch(add_to_cart({
//                 userId: userInfo.id,
//                 quantity,
//                 productId : id,// product._id,
//                 portionSize: portionSize
//             }))
//             setPortionSize('')
//         } else {
//             navigate('/login')
//         }
//     }
        
//     const add_to_wishlist_local = (pro) => {
//         if (userInfo) {
//             //console.log(pro)
//             dispatch(add_to_wishlist({
//                 userId: userInfo.id,
//                 productId: pro._id,
//                 name: pro.name,
//                 price: pro.price,
//                 image: pro.images[0],
//                 discount: pro.discount,
//                 rating: pro.rating,
//                 slug: pro.slug,
//                 portionSizes: pro.portionSizes,
//                 description: pro.description,
//                 byThePan: pro.byThePan
//             }))
//         } else {
//             navigate('/login')
//         }
//     }

//     const redirect_chat_page = (chatTopic) => {
//         if (userInfo) {
//             navigate(`/customerDashboard/chat/${chatTopic}`)
//         } else {
//             navigate('/login')
//         }
//     }

//     if (!isOpen || !product) return null;
//     //console.log('Rendering Modal2 for product:', product);
//     return (
//         <div id='wrapper' onClick={handleClose} 
//             className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//             {
//                 setPaymentsAndQuantitiesLocal()
//                 // bg-white bg-[${sellerSecondaryColor1}]
//                 // style= backgroundcolor not working in modal popup
//             }
//             <div id='modal' className={`bg-white z-1000 border-2 p-3 shadow-xl w-full max-w-md `}
//                 style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                 <div className="flex justify-between items-center mb-4">
//                     <div className="text-xl font-semibold">{product.name}</div>
//                     <button onClick={onClose} 
//                         className='w-[34px] h-[34px] border-none border-gray-700 text-gray-700 hover:bg-gray-700 cursor-pointer 
//                         flex justify-center items-center rounded-full hover:rotate-[720deg] transition-all bg-white hover:text-white'>
//                         <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                         </svg>
//                     </button>
//                 </div>
//                 <div>
//                     <div className='grid grid-cols-2 gap-2 justify-between items-center'>
//                         <div className={` relative group h-[210px] md:h-[270px] xs:h-[170px] overflow-hidden `} >
//                             <SkeletonWithImage className={`sm:w-full object-cover border`} style={{height:'100%', width:'100%', borderColor:sellerPrimaryColor1}} 
//                                 src={product.images[0]} alt="productImage" />   
//                             <div className="hidden relative text-center">
//                                 <img className={`sm:w-full object-cover`} style={{height:'100%', width:'100%'}} src={product.images[0]} alt="" />   
//                                 <div className={` ${product.byThePan === 'NoPan' ? 'hidden' : ''} w-full absolute top-0 left-0 text-center`}
//                                     style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                     {product.byThePan}
//                                 </div>
//                             </div>
//                             { /*<img className='sm:w-full w-full h-[240px]' src={product.images[0]} alt="" /> */ }
                            
//                             <ul className={`group-hover:bottom-6 flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full`}>
//                                 {/* hover:bg-[#059473] hover:text-white hover:rotate-[720deg]  */}
//                                 <li onClick={() => add_to_cart_local(product._id)} 
//                                     className='w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all'
//                                     style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                     <div className="icon-container">
//                                         <span className='icon flex justify-center items-center'>
//                                             +<MdOutlineRestaurantMenu />&nbsp;
//                                         </span>
//                                         <div className="tooltipSmall" style={tooltipHoverStyle}>Add To<br />{sellerShoppingTerm}</div>
//                                     </div>
//                                 </li>
//                                 <li onClick={() => add_to_wishlist_local(product)}
//                                     className={` ${sellerBoolShowSiteWishList ? '' : 'hidden' } 
//                                     w-[38px] h-[38px] cursor-pointer bg-white border flex justify-center items-center rounded-full transition-all` }
//                                     style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                     <div className="icon-container">
//                                         <span className='icon flex justify-center items-center'>
//                                             &nbsp;<FaHeart />&nbsp;
//                                         </span>
//                                         <div className="tooltipSmall" style={tooltipHoverStyle}>Add To<br />Wishlist</div>
//                                     </div>  
//                                 </li>
//                                 <li>
//                                     <Link to={`/product/details/${product._id}`}  
//                                         className='w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all'
//                                         style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                         <div className="icon-container">
//                                             <span className='icon flex justify-center items-center'>
//                                                 &nbsp;<FaEye />&nbsp;
//                                             </span>
//                                             <div className="tooltipSmall" style={tooltipHoverStyle}>More<br />Details</div>
//                                         </div>
//                                     </Link>     
//                                 </li>
                                
//                                 <span onClick={() => redirect_chat_page(product.name)} 
//                                     className={` ${sellerBoolShowSiteChat ? '' : 'hidden'} 
//                                     w-[38px] h-[38px] cursor-pointer bg-white border flex justify-center items-center rounded-full transition-all` }
//                                     style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                     <div className="icon-container">
//                                         <span className='icon flex justify-center items-center'>
//                                             &nbsp;<IoChatbubbleEllipsesSharp />&nbsp;
//                                         </span>
//                                         <div className="tooltipSmall" style={tooltipHoverStyle}>Chat<br />With Us</div>
//                                     </div>
//                                 </span>
//                             </ul>  
//                         </div>
//                         <div className={`h-[210px] md:h-[270px] xs:h-[170px]`}>
//                             <textarea className='h-[210px] md:h-[270px] xs:h-[170px] border outline-0 w-full p-1' 
//                                 style={{color:sellerPrimaryColor1,  backgroundColor:sellerSecondaryColor1, borderColor:sellerPrimaryColor1}}
//                                 value={product.description} />
//                         </div>
//                     </div>
//                     <div className='grid grid-cols-2 gap-2 p-1 border-none '>
//                         <div className='grid grid-cols-2 gap-2 p-1'>           
//                             <span className={`${sellerBoolShowSitePayments ? 'text-md font-semibold border-none' : 'hidden'}`}>
//                                 {currencyFormat.format(product.price)}
//                             </span>
//                             <span className={` ${sellerBoolShowSiteProductQuantities ?  '' : 'hidden' } 
//                                 flex border rounded-lg w-[60px] h-[24px] mb-1 justify-center items-center `}
//                                 style={{borderColor:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                 <div onClick={cartProductQuantityDecrementLocal}  
//                                     className='px-1 cursor-pointer text-[15px] font-semibold' style={{color:sellerPrimaryColor1}}>-</div> 
//                                 <div className='px-1 text-[15px] font-semibold' style={{color:sellerPrimaryColor1}}>{quantity}</div> 
//                                 <div onClick={cartProductQuantityIncrementLocal}  
//                                     className='px-1 cursor-pointer text-[15px] font-semibold' style={{color:sellerPrimaryColor1}}>+</div> 
//                             </span>
//                             <div className={`${sellerBoolShowSiteRating ? 'flex border-none' : 'hidden'} `}>
//                                 <Rating ratings={product.rating} />
//                             </div>
//                         </div>
//                         <div className={`${product.portionSizes !== '' ? 'w-full' : 'hidden'} `}>
//                             <select onChange={(e) => setPortionSize(e.target.value)} id='' name='' 
//                                 className='border rounded-md px-1 py-1 mb-1 w-full text-[14px] font-semibold' 
//                                 style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                 <option value=''>Choose Portion Size</option>
//                                 {
//                                     product.portionSizes.split(';').map((p,i) => {
//                                         return( <option key={i} value={p}>{p}</option> )
//                                     })
//                                 }
//                             </select>
//                         </div>
//                     </div>
//                     <div className='gap-2 p-1 border mt-1 text-sm' 
//                         style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                         <span className='font-semibold'>{sellerProductTerm} Details: </span>
//                         <span className={` ${product.FMP === '' ? 'hidden' : 'mr-1'} `}>
//                             {product.FMP};
//                         </span> 
//                         <span className='mr-1'>
//                             Category: <b>{product.category}</b>;
//                         </span>
//                         <span className={` ${product.allergies !== 'None' ? 'font-semibold text-red-500' : ''} mr-1`}>
//                             Allergies: <b>{product.allergies}</b>; 
//                         </span>
//                         <span className={` ${sellerBoolShowSiteCookingMethods ? 'mr-1' : 'hidden'} `}>
//                             Cooking Method: <b>{product.cookingMethod}</b>; 
//                         </span>
//                         <span className={` ${product.byThePan === 'NoPan' ? 'hidden' : 'mr-1'} `}>
//                             By The Pan: <b>{product.byThePan}</b>; 
//                         </span>
//                         <span className={` ${product.dietaryRestrictions === 'None' ? 'hidden' : 'mr-1'} `}>
//                             Dietary Restrictions: <b>{product.dietaryRestrictions}</b>;  
//                         </span>
//                         <span className={` ${sellerBoolShowCuisineType ? 'mr-1' : 'hidden'} `}>
//                             Cuisine Type: <b>{product.cuisineType}</b> 
//                         </span>
//                         <span className={` ${sellerBoolShowSiteHoliday ? 'mr-1' : 'hidden'} `}>
//                             <span className={` ${product.holiday === 'None' ? 'hidden' : 'mr-1'} `}>
//                                 Holiday: <b>{product.holiday}</b> 
//                             </span>
//                         </span> 
//                     </div>
//                     <div className='gap-2 p-1 border text-sm italic mt-2'
//                         style={{color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1, borderColor:sellerPrimaryColor1}}>
//                         {sellerCompanyMarketingLine1}
//                     </div>
//                     {/*flex justify-center gap-1 mt-1*/}
//                     <div className='flex justify-center gap-1 mt-1 xs:grid xs:grid-cols-2' >
//                         <div>
//                             <Link to={`/product/details/${product._id}`} style={{backgroundColor:sellerPrimaryColor1}} 
//                                 className='p-3 mt-1 h-[34px] w-[130px] xs:w-[152px] xs:mr-2 text-sm font-semibold text-white flex justify-center items-center rounded-lg'>
//                                 <FaEye className='mr-1' /> More Details
//                             </Link>
//                         </div>
//                         <div>
//                             <button onClick={() => add_to_cart_local(product._id)} 
//                                 className='p-3 mt-1 h-[34px] w-[154px] xs:w-[154px] text-sm font-semibold flex rounded-lg text-md cursor-pointer 
//                                 justify-center items-center hover:shadow-lg hover:shadow-green-500/40] text-white' 
//                                 style={{backgroundColor:sellerPrimaryColor1}}>
//                                 {
//                                     userInfo ? 
//                                     <><MdOutlineRestaurantMenu className='mr-1' /> Add To {sellerShoppingTerm}</>
//                                     : 
//                                     <><FaUser className='mr-1' /> Please Login</>
//                                 }
//                             </button> 
//                         </div>
//                         <div>
//                             <button onClick={onClose} style={{backgroundColor:sellerPrimaryColor1}}
//                                 className="p-3 mt-1 h-[34px] w-[80px] xs:w-[152px] text-sm font-semibold text-white flex justify-center items-center rounded-lg">
//                                 <IoIosCloseCircle className='mr-1'/> Close
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Modal2;


